<template>
    <div class="bgc">
        <div style="width:94%; margin:0 auto;">
            <van-steps direction="vertical"  inactive-icon="checked" active-icon="checked">
                <van-step v-for="(item,index) in StepsList" :key="index">
                    <p>{{item.createTime}}</p>
                    <p>{{item.note}}</p>
                    <button class="button" v-if="orderSn && item.returnStatus == 2" @click="buttonOrderSn">填写订单号</button>
                    <!-- 退货并且returnStatus==2 -->
                </van-step>
            </van-steps>
        </div>
        <div class="absolute">
          <van-button type="danger" block @click="PlaceAnOrder">查看申请</van-button>
        </div>
        <van-dialog v-model="dialogShow" title="温馨提示" show-cancel-button @confirm="confirma" @close="close">
          <div> <input type="text" class="text" placeholder="请输入物流公司" v-model="returnDeliveryCompany"></div>
          <div> <input type="text" class="text" placeholder="请输入运单号" v-model="returnDeliverySn"></div>
        </van-dialog>
    </div>
</template>
<script>
import { afterOperateList, afterInfo, afterReturnDeliverySn } from '@/request/api.js'
import { Step, Steps, button, Dialog, Toast } from 'vant'
export default {
  components: {
    [Step.name]: Step,
    [Steps.name]: Steps,
    [button.name]: button,
    [Toast.name]: Toast,
    [Dialog.Component.name]: Dialog.Component
  },
  data() {
    return {
      StepsList: [],
      orderSn: false,
      dialogShow: false,
      returnDeliveryCompany: '',
      returnDeliverySn: ''
    }
  },
  methods: {
    PlaceAnOrder() {
      if (this.$route.query.MultiCommodity) {
        this.$router.push({ path: '/afterrecords', query: { id: this.$route.query.id, MultiCommodity: this.$route.query.MultiCommodity } })
      } else {
        this.$router.push({ path: '/afterrecords', query: { id: this.$route.query.id } })
      }
    },
    buttonOrderSn() {
      this.dialogShow = true
    },
    confirma() {
      if (this.returnDeliverySn) {
        if (this.returnDeliveryCompany) {
          const params = {
            orderItemId: this.$route.query.orderItemListId,
            returnDeliverySn: this.returnDeliverySn,
            returnDeliveryCompany: this.returnDeliveryCompany
          }
          afterReturnDeliverySn(params).then(res => {
            if (res.code === 200) {
              this.orderSn = false
              Toast.success(res.message)
            } else {
              Toast.fail(res.message)
            }
            console.log(res)
          })
        } else {
          Toast.fail('请填写退货的物流公司')
        }
      } else {
        Toast.fail('请填写退货的物流单号')
      }
    },
    close() {
      this.returnDeliverySn = ''
      this.returnDeliveryCompany = ''
    }
  },
  created() {
    afterOperateList({ returnId: this.$route.query.id }).then(res => {
      console.log(res)
      if (res.code === 200) {
        this.StepsList = res.data.list
      }
    }).catch(res => {

    })
    afterInfo({ returnId: this.$route.query.id }).then(res => {
      if (res.code === 200) {
        if (res.data.type === 2) {
          console.log('退货')
          this.orderSn = true
        } else {
          this.orderSn = false
        }
      }
    }).catch(res => {
      console.log(res)
    })
  }
}
</script>
<style lang="less" scoped>
.button{
  padding:0px 15px;
  height: 60px;
  border: 0.4px solid #ccc;/*no*/
  background-color: #fff;
  font-size: 26px;
  margin-top: 20px;
}
.bgc{
    min-height: 100vh;
}
.van-steps{
    background: none;
}
/deep/ .van-step__icon{
    color: #B4272D;
    font-size: 30px;
}
/deep/ .van-step__title{
    color: #333333;
    margin-left: 30px;
    p{
      margin-top: 10px;
    }
}
/deep/.van-step--vertical{
    margin-top: 10px;
    padding-bottom: 0px;
    background-color: #fff;
}
/deep/ [class*=van-hairline]::after{
    border: none;
}
p{
    line-height: 35px;
    font-size: 26px;
}
/deep/.van-step--vertical .van-step__circle-container{
    top: 50px;
}
/deep/ .van-button--danger{
  background: rgba(180,39,45,1);
  height: 100%;
}
.absolute {
    width: 100%;
    position: fixed;
    bottom: 0;
    height:98px;
    background:rgba(255,255,255,1);
}
/deep/ .van-dialog__header{
  height: 50px;
  font-size: 32px;
  padding: 40px 0px;
}
.van-dialog {
  width: 560px !important;
}
.text{
  width:495px;
  height:70px;
  border:0.4px solid rgba(102,102,102,1);/*no*/
  border-radius:4px;
  margin-left: 33px;
  margin-bottom: 24px;
}
input::placeholder{
  padding-left: 10px;
  font-size: 28px;
  color: #999999;
}
/deep/.van-dialog__content{
  margin-bottom: 40px;
}
/deep/ .van-button--large{
  height: 100px !important;
}
/deep/ .van-dialog__confirm{
  background-color: #B4272D;
}
/deep/ .van-dialog__confirm{
  color: white;
}
</style>
